export default "__VITE_ASSET__C9BunGE5__"